import { Routes, Route } from 'react-router-dom';
import { Landing } from './pages/Landing';
import { NotFound } from './pages/NotFound';
import { SignIn } from './pages/SignIn';
import { SignUp } from './pages/SignUp';
import { Dashboard } from './pages/Dashboard';
import { Settings } from './pages/Settings';
import { Workspace } from './pages/Workspace';
import { CourseDetail } from './pages/CourseDetail';
import { JoinCourse } from './pages/JoinCourse';
import { AssessmentEditor } from './pages/AssessmentEditor';
import { AssessmentTaker } from './pages/AssessmentTaker';
import { AttemptResult } from './pages/AttemptResult';
import { Inbox } from './pages/Inbox';
import { Tutor } from './pages/Tutor';
import { StudyRoom } from './pages/StudyRoom';
import { Privacy } from './pages/Privacy';
import { VibeSpace } from './pages/VibeSpace';
import { Templates } from './pages/Templates';
import { ProtectedRoute } from './components/ProtectedRoute';
import { EduBorgCompanion } from './components/EduBorg/Companion';

export function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/space/:orgSlug" element={<VibeSpace />} />
        <Route path="/templates" element={<Templates />} />
        <Route path="/auth/sign-in" element={<SignIn />} />
        <Route path="/auth/sign-up" element={<SignUp />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/settings"
          element={
            <ProtectedRoute>
              <Settings />
            </ProtectedRoute>
          }
        />
        <Route
          path="/workspace"
          element={
            <ProtectedRoute>
              <Workspace />
            </ProtectedRoute>
          }
        />
        <Route
          path="/c/:orgSlug/:courseSlug"
          element={
            <ProtectedRoute>
              <CourseDetail />
            </ProtectedRoute>
          }
        />
        <Route
          path="/join"
          element={
            <ProtectedRoute>
              <JoinCourse />
            </ProtectedRoute>
          }
        />
        <Route
          path="/join/:joinCode"
          element={
            <ProtectedRoute>
              <JoinCourse />
            </ProtectedRoute>
          }
        />
        <Route
          path="/c/:orgSlug/:courseSlug/assessments/:itemId/edit"
          element={
            <ProtectedRoute>
              <AssessmentEditor />
            </ProtectedRoute>
          }
        />
        <Route
          path="/c/:orgSlug/:courseSlug/assessments/:itemId/take"
          element={
            <ProtectedRoute>
              <AssessmentTaker />
            </ProtectedRoute>
          }
        />
        <Route
          path="/c/:orgSlug/:courseSlug/assessments/:itemId/result/:attemptId"
          element={
            <ProtectedRoute>
              <AttemptResult />
            </ProtectedRoute>
          }
        />
        <Route
          path="/messages"
          element={
            <ProtectedRoute>
              <Inbox />
            </ProtectedRoute>
          }
        />
        <Route
          path="/messages/:conversationId"
          element={
            <ProtectedRoute>
              <Inbox />
            </ProtectedRoute>
          }
        />
        <Route
          path="/tutor"
          element={
            <ProtectedRoute>
              <Tutor />
            </ProtectedRoute>
          }
        />
        <Route
          path="/c/:orgSlug/:courseSlug/study"
          element={
            <ProtectedRoute>
              <StudyRoom />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <EduBorgCompanion />
    </>
  );
}
